"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _commonMedia = require("@mmc/common-media");
var _image = require("./image-640.propTypes");
var _image2 = require("./image-640.config");
var _image3 = _interopRequireDefault(require("./image-640.css"));
var Image640 = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Image640, _React$Component);
  function Image640() {
    return _React$Component.apply(this, arguments) || this;
  }
  Image640.resourceType = function resourceType() {
    return '640Image_1_0_0';
  };
  var _proto = Image640.prototype;
  _proto.render = function render() {
    var _clsx;
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme;
    var alignment = _image2.alignmentMap[data.offset] || _image2.alignmentMap["default"];

    // Forcefully setting noCropMobile option as true for "inset" offset
    // as the image was being invisible on mobile devices
    if (data.offset === 'inset') {
      data.noCropMobile = true;
    }
    var mediaClasses = [_image3["default"].image, _image3["default"][_image2.mobileFocusAreaClassesMap[data.mobileFocusArea]], data.noCropMobile && _image3["default"].noCropMobile].filter(Boolean);
    var noTopPaggingMobile = data.noTopPaggingMobile,
      background = data.background;
    var darkThemeClasses = background === 'dark' ? _image3["default"].darkTheme : '';
    var removeTopClass = noTopPaggingMobile ? _image3["default"].noTopPaggingMobile : '';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme['container-fluid'], _image3["default"].noGutters, removeTopClass, darkThemeClasses)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme.row, _image3["default"].noGutters)
    }, data.offset && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme['col-xs-12'], _image3["default"].imageContainer, _image3["default"].noGutters)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_image3["default"][alignment], (_clsx = {}, _clsx[_image3["default"].imageWrapper] = !data.noCropMobile, _clsx))
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoad["default"], {
      offsetBottom: 200
    }, /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
      theme: theme,
      mediaClasses: mediaClasses,
      containerClasses: [theme.marginBottom40],
      size: 2160,
      image: data.image,
      video: data.video,
      hideVideoOnMobile: data.hideVideoOnMobile
    }))))));
  };
  return Image640;
}(_react["default"].Component);
exports["default"] = Image640;
Image640.displayName = 'Image640';